import React from "react";
import {
    Theme as DesignSystemTheme,
    ThemeName,
    useApplyGlobalThemeEffect
} from "@octopusdeploy/design-system-components";

interface ThemeProps {
    themeName: ThemeName;
}

const Theme = ({themeName, children}: React.PropsWithChildren<ThemeProps>) => {
    useApplyGlobalThemeEffect(themeName, undefined, false);

    return (
        <DesignSystemTheme themeName={themeName}>
            {children}
        </DesignSystemTheme>
    );
};

export default Theme;
